module.exports = __webpack_public_path__ + "img/sec4_1_.34b22ac4.png";